import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent, FormExtendedCheckboxComponent, InputComponent } from '@akostm/orbit-ui';
import { DomainType } from '../general.service';

export interface DomainDialogData {
  form: FormGroup;
  title: string;
  subTitle?: string;
  domainType: DomainType;
  cancelLabel: string;
  confirmLabel: string;
  isUpdate?: boolean; // Flag to indicate if this is an update operation
  hasClientDomain?: boolean; // Flag to indicate if a client domain already exists
  hasMainDomain?: boolean; // Flag to indicate if a main domain already exists
}

@Component({
  selector: 'wire-domain-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    ButtonComponent,
    InputComponent,
    FormExtendedCheckboxComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './domain-dialog.component.html',
  styleUrls: ['./domain-dialog.component.scss'],
})
export class DomainDialogComponent {
  readonly data = inject<DomainDialogData>(DIALOG_DATA);
  readonly #dialogRef = inject(DialogRef);
  readonly form = this.data.form;


  get showClientOption(): boolean {
    return !this.data.hasClientDomain;
  }

  get showMainOption(): boolean {
    return !this.data.hasMainDomain;
  }

  onCancel(): void {
    this.#dialogRef.close(false);
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.#dialogRef.close(true);
    } else {
      this.form.markAllAsTouched();
    }
  }

  get domainType() {
    return this.form.get('domainType') as FormControl<DomainType>;
  }

  get domain() {
    return this.form.get('domain') as FormControl<string>;
  }
}
